(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('CovidFacilityLabDialogController', CovidFacilityLabDialogController);

    CovidFacilityLabDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CovidFacilityLab', 'CoreService', 'Facility', 'FacilityLab'];

    function CovidFacilityLabDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CovidFacilityLab, CoreService, Facility, FacilityLab) {
        var vm = this;

        vm.covidFacilityLab = entity;
        vm.clear = clear;
        vm.save = save;
        vm.facility = CoreService.getCurrentFacility();
        vm.facilitylabs = [];

        FacilityLab.filter({facilityId: vm.facility.id, page: 0, size: 1000}, function (result) {
            vm.facilitylabs = result;
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.covidFacilityLab.id !== null) {
                CovidFacilityLab.update(vm.covidFacilityLab, onSaveSuccess, onSaveError);
            } else {
                CovidFacilityLab.save(vm.covidFacilityLab, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:covidFacilityLabUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
